import numeral from "numeral";
import { useEffect, useMemo, useState } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { calculateBasicLiquidityRatio } from "../../../functions/Balance/basic-liquidity-ratio";
import { calculateDebtToTotalAssets } from "../../../functions/Balance/debt-to-total-assets";
import { cn } from "../../../utils/useFunctions";
import { PdfCard, PdfCardGray, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_BLUE_11,
  STYLE_PDF_TEXT_MEDIUM_GRAY_11,
  STYLE_PDF_TEXT_NORMAL_11,
  STYLE_PDF_TEXT_SEMIBOLD_BLUE_14,
} from "../styles/pdf.style";
import { SumDebtPersonalValue } from "../../../functions/Balance/sumValueBalance";
import { sumCapitalInvest, sumDebtInvest } from "../../../functions/Balance/sumProperty";

// สร้าง PDF การเงินหน้าที่สองโดยใช้อัตราส่วนจาก owner กลาง แทน aggregate สินทรัพย์และรายจ่ายเดิม
function PdfPageFinacialTwo({ page }) {
  const balanceData = useBalanceStore((state) => state.balanceData);

   const [addInvest, setAddInvest] = useState(
      balanceData?.property_invest_list ? balanceData?.property_invest_list : []
    );
  const [ReturnInsurance, setReturnInsurance] = useState([]);

  useEffect(() => {
      if (balanceData) {
        let tempInsuranceReturn = balanceData?.expenses_fixed_list
          ?.filter(
            (item) => item.options_expenses_fixed === "expenses_insuarant_life"
          )
          ?.map((item) => item.expenses_insuarant_lifes)
          ?.flat();
  
        let tempBalanceData = {};
        //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//
  
        if (
          balanceData?.property_invest_list
            ?.map((item) => item.options_property_invest_title)
            .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
          tempInsuranceReturn?.length === 0
        ) {
          // ถ้ามีหัวข้อนี้อยู่แล้ว
          let tempNameList = balanceData?.property_invest_list
            .find(
              (item) =>
                item?.options_property_invest_title ===
                "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
            )
            ?.invest_other_lists?.filter((item) => item !== null)
            ?.map((item) => item?.title);
  
          let tempInvestList = balanceData?.property_invest_list?.map((item) => {
            if (item?.invest_other_lists) {
              let tempData = tempInsuranceReturn
                ?.map((item2) => {
                  if (!tempNameList?.includes(item2.title))
                    return {
                      amount: item2?.more_details?.policy_surrender_value,
                      created: item2.created,
                      reward_amount_per_year: item?.reward_amount_per_year || 1,
                      target_invest: {},
                      title: item2.title,
                      editable: false,
                    };
                })
                .filter((item) => item !== undefined);
              return {
                ...item,
                invest_other_lists: [...item.invest_other_lists, ...tempData],
              };
            }
            return item;
          });
  
          tempBalanceData = tempInvestList;
        } else {
          // ถ้ายังไม่มีหัวข้อนี้อยู่
          let tempInvestList = tempInsuranceReturn?.map((item) => {
            return {
              amount: item?.more_details?.policy_surrender_value,
              created: item.created,
              reward_amount_per_year: item?.reward_amount_per_year || 1,
              target_invest: item?.target_invest || {},
              title: item.title,
              editable: true,
            };
          });
  
          tempBalanceData = tempInvestList;
        }
        setReturnInsurance(tempBalanceData);
      }
      //==============================================//
    }, [balanceData]);

  const sumExpensesInvestSaving = balanceData?.sum_expenses_invest_saving
    ? balanceData?.sum_expenses_invest_saving
    : 0;
  const expenseValue = balanceData?.expenses_propotion
    ? balanceData?.expenses_propotion - sumExpensesInvestSaving
    : 0;
  const salary_propotion_per_month = balanceData?.salary_propotion / 12;

  // รายรับ
  const salaryValue = balanceData?.salary_propotion
    ? balanceData?.salary_propotion
    : 0;
  const expensesPerSalary = ((expenseValue / salaryValue) * 100)?.toFixed(2);

  const checkResultExpenses = () => {
    if (expenseValue > salaryValue / 2) {
      return "normal";
    } else {
      return "good";
    }
  };
  const getDesc = () => {
    if (checkResultExpenses() === "normal") {
      return `คุณมีช่องทางรายรับไม่หลากหลาย`;
    }
    return `คุณมีรายรับหลากหลายช่องทาง`;
  };

  // รายรับ
  const salaryValueIncome = balanceData?.salary_propotion
    ? balanceData?.salary_propotion
    : 0;
  const expensesPerSalaryOutcome = (
    (expenseValue / salaryValueIncome) *
    100
  )?.toFixed(2);
  const getDescOutcome = () => {
    if (checkResultExpenses() === "normal") {
      return `คุณมีรายจ่าย รวม ${numeral(expenseValue)?.format(
        "0,0"
      )} บาท หรือ ${
        String(expensesPerSalaryOutcome) === "Infinity"
          ? 0
          : expensesPerSalaryOutcome
      } % ซึ่งน้อยกว่าครึ่งนึงของรายรับ`;
    }

    return `คุณมีรายจ่าย รวม ${numeral(expenseValue)?.format(
      "0,0"
    )} บาท หรือ ${expensesPerSalaryOutcome} % ซึ่งมากกว่าครึ่งนึงของรายรับ`;
  };

  // สภาพคล่องพื้นฐาน
  const {
    ratio: basicLiquidityRatio,
    status: basicLiquidityStatus,
  } = calculateBasicLiquidityRatio({ balanceData });
  const checkProperty = basicLiquidityRatio;
  const checkResultProperty = () => basicLiquidityStatus;
  const checkPropertyIcon = () => {
    const status = checkResultProperty();
    if (status === "bad") {
      return "/images/bad_finance.svg";
    }
    if (status === "good") {
      return "/images/happy_finance.svg";
    }
    if (status === "chance") {
      return "/images/chance_finance.svg";
    }
  };
  const checkPropertTitle = () => {
    const status = checkResultProperty();
    if (status === "no_data") {
      return (
        <div className="text-[13px] font-semibold text-center text-gray90">
          ข้อมูลไม่เพียงพอเนื่องจากสินทรัพย์สภาพคล่องหรือรายจ่ายต่อเดือนเป็น 0
          จึงไม่สามารถคำนวณได้
        </div>
      );
    }
    if (status === "bad") {
      return (
        <div className="text-[14px] font-semibold text-center  text-[#FF0000]">
          คุณมีอัตราส่วนสภาพคล่อง {numeral(checkProperty)?.format("0[.]00")} เท่า
          ซึ่งน้อยกว่า 6 เท่า
        </div>
      );
    }
    if (status === "good") {
      return (
        <div className="text-[14px] font-semibold text-center   text-maingreen">
          คุณมีอัตราส่วนสภาพคล่องพื้นฐาน 6 เท่า
        </div>
      );
    }
    return (
      <div className="text-[14px] font-semibold text-center   text-mainyellow ">
        คุณมีอัตราส่วนสภาพคล่อง {numeral(checkProperty)?.format("0[.]00")} เท่า
        ซึ่งมากกว่า 6 เท่า
      </div>
    );
  };

  // หนี้สินต่อสินทรัพย์
  const { ratio: getDebttoTotalAsset } = useMemo(
    () =>
      calculateDebtToTotalAssets({
        balanceData,
        addInvest,
        returnInsurance: ReturnInsurance,
      }),
    [balanceData, addInvest, ReturnInsurance]
  );
  const checkDebttoAssetIcon = () => {
    const status = getDebttoTotalAsset;
    if (status > 50) {
      return "/images/bad_finance.svg";
    } else {
      return "/images/happy_finance.svg";
    }
  };
  const checkDebttoAssetTitle = () => {
    const status = getDebttoTotalAsset;
    if (status > 50) {
      return (
        <div className="text-[13px] font-semibold text-center  text-[#FF0000]">
          คุณมีอัตราส่วนหนี้สินต่อสินทรัพย์ {getDebttoTotalAsset?.toFixed(2)} %
          ซึ่งมากกว่า 50%
        </div>
      );
    } else {
      return (
        <div className="text-[13px] font-semibold text-center  text-maingreen">
          คุณมีอัตราส่วนหนี้สินต่อสินทรัพย์ {getDebttoTotalAsset?.toFixed(2)}%
          ซึ่งน้อยกว่า 50%
        </div>
      );
    }
  };

  // การชำระหนี้สินต่อรายรับ
  const getDebttoSalary = useMemo(() => {
    let sum = 0;
    const debtPermonth =
      balanceData?.sum_debt_short_permonth +
      balanceData?.sum_debt_long_permonth;
    const salaryPermonth = balanceData?.salary_propotion
      ? balanceData?.salary_propotion / 12
      : 0;
    sum = salaryPermonth > 0 ? (debtPermonth / salaryPermonth) * 100 : 0;
    return sum;
  }, [balanceData]);
  const checkDebttoSalaryIcon = () => {
    const status = getDebttoSalary;
    if (status > 50) {
      return "/images/bad_finance.svg";
    } else {
      return "/images/happy_finance.svg";
    }
  };
  const checkDebttoSalaryTitle = () => {
    const status = getDebttoSalary;

    if (salary_propotion_per_month <= 0) {
      return (
        <div className="text-[13px] font-semibold text-center text-gray90">
          ข้อมูลไม่เพียงพอเนื่องจากรายรับเป็น 0 จึงไม่สามารถคำนวนได้
        </div>
      );
    }

    if (status > 50) {
      return (
        <div className="text-[13px] font-semibold text-center text-[#FF0000]">
          คุณมีอัตราส่วนการชำระหนี้ต่อต่อรายรับ {getDebttoSalary?.toFixed(2)} %
          ซึ่งมากกว่า 50% *
        </div>
      );
    } else {
      return (
        <div className="text-[13px] font-semibold text-center text-maingreen">
          คุณมีอัตราส่วนการชำระหนี้ต่อต่อรายรับ {getDebttoSalary?.toFixed(2)} %
          ซึ่งน้อยกว่า 35% - 50% *
        </div>
      );
    }
  };

  // การออม
  const getConservation = useMemo(() => {
    let sum = 0;
    if (balanceData?.sum_expenses_invest_saving) {
      sum = balanceData?.sum_expenses_invest_saving;
    }
    const finalResult =
      sum > 0 ? (sum / balanceData?.salary_propotion) * 100 : 0;
    return finalResult;
  }, [balanceData]);
  const salaryValuePercent = (salaryValue * 10) / 100;
  const checkConservationIcon = () => {
    const status = getConservation;
    if (status > 10) {
      return "/images/happy_finance.svg";
    } else {
      return "/images/bad_finance.svg";
    }
  };
  const checkConservationTitle = () => {
    const status = getConservation;

    if (balanceData?.salary_propotion <= 0) {
      return(
        <div className="text-[13px] font-semibold text-center text-gray90">
        ข้อมูลไม่เพียงพอเนื่องจากรายรับเป็น 0 จึงไม่สามารถคำนวนได้
      </div>
      )
    }

    if (status > 10) {
      return (
        <div className="text-[13px] font-semibold text-center text-maingreen">
          คุณมีอัตราส่วนการออม{" "}
          {numeral(balanceData?.sum_expenses_invest_saving).format("0,0")} บาท
          หรือ {getConservation?.toFixed(2)} % ซึ่งมากกว่า 10 % *
        </div>
      );
    } else {
      return (
        <div className="text-[13px] font-semibold text-center text-[#FF0000]">
          คุณมีอัตราส่วนการออม
          {numeral(balanceData?.sum_expenses_invest_saving).format(
            "0,0.00"
          )}{" "}
          บาท หรือ {getConservation?.toFixed(2)} % ซึ่งน้อยกว่า 10 % *
        </div>
      );
    }
  };

  const getNetWealth = useMemo(() => {
    let result = 0;
    if (balanceData?.property_propotion) {
      result = balanceData?.debt_propotion
        ? Number(balanceData?.property_propotion) -
          Number(balanceData?.debt_propotion)
        : 0;
    }
    if (result > 0) {
      return result;
    } else {
      return 0;
    }
  }, [balanceData?.property_propotion, balanceData?.debt_propotion]);

  // การลงทุน
  const getInvest = useMemo(() => {
    let sum = 0;
    if ((SumDebtPersonalValue(balanceData) +
                  sumCapitalInvest(addInvest, ReturnInsurance) +
                  sumDebtInvest(balanceData)) > 0) {
      sum =
        balanceData?.net_wealth > 0
          ? ((SumDebtPersonalValue(balanceData) +
              sumCapitalInvest(addInvest, ReturnInsurance) +
              sumDebtInvest(balanceData)) / balanceData?.net_wealth) * 100
          : 0;
    }
    return sum;
  }, []);
  const checkInvestIcon = () => {
    const status = getInvest;
    if (status > 50) {
      return "/images/happy_finance.svg";
    } else {
      return "/images/bad_finance.svg";
    }
  };
  const checkInvestSubtitle = () => {
    const status = getInvest;
    if (status > 50) {
      return (
        <div className="text-[13px] font-semibold text-center  text-maingreen">
          คุณมีอัตราส่วนการลงทุน {getInvest?.toFixed(2)} % ซึ่งมากกว่า 50 %
        </div>
      );
    } else {
      return (
        <div className="text-[13px] font-semibold text-center  text-[#FF0000]">
          คุณมีอัตราส่วนการลงทุน {getInvest?.toFixed(2)} % ซึ่งน้อยกว่า 50 %
        </div>
      );
    }
  };

  const evulatePropertyItems = useMemo(() => {
    const newPropertyItems = [
      {
        label: "การชำระหนี้ต่อรายรับ",
        label_gray: "(ไม่ควรเกิน 35 - 50%)",
        label_icon: "credit-card.svg",
        icon: salary_propotion_per_month <= 0 ? null : checkDebttoSalaryIcon(),
        title: checkDebttoSalaryTitle(),
        desc: `อัตราการชำระหนี้ต่อรายรับ = หนี้สินต่อเดือน / รายรับต่อเดือน`,
        desc_gray:
          salary_propotion_per_month <= 0
            ? null
            : `${getDebttoSalary?.toFixed(2)} % = (
        ${numeral(
          balanceData?.sum_debt_short_permonth +
            balanceData?.sum_debt_long_permonth
        ).format("0,0")}
        / ${numeral(salary_propotion_per_month).format("0,0")} * 100 )`,
        is_detail: salary_propotion_per_month <= 0 ? false : true,
        detail: `ควรวางแผนบริหารหนี้เช่น หาทางเพิ่มรายรับ ลดรายจ่ายไม่จำเป็น รักษาสภาพคล่อง`,
      },
      {
        label: "การออม",
        label_gray: "(ควรมากกว่า 10 % ของรายรับ)",
        label_icon: "piggy-bank.svg",
        icon:
          balanceData?.salary_propotion <= 0 ? null : checkConservationIcon(),
        title: checkConservationTitle(),
        desc: `(ค่าใช้จ่ายเพื่อการออมและการลงทุน/รายรับรวม) x 100 *รายรับ`,
        desc_gray:
          balanceData?.salary_propotion <= 0 
            ? null
            : `*รายรับ ${numeral(salaryValue).format("0,0.00")} บาท
        10% ของรายรับคือ ${numeral(salaryValuePercent).format("0,0.00")} บาท`,
        is_detail: getConservation <= 10 && balanceData?.salary_propotion > 0,
        detail: `คุณควรเพิ่มการออมอีก ${numeral(
          salaryValuePercent - balanceData?.sum_expenses_invest_saving
        ).format("0,0.00")} บาท`,
      },
      {
        label: "การลงทุน",
        label_gray: "(ควรมากกว่า 50% ของรายรับ)",
        label_icon: "chart_bar_pdf.svg",
        icon: checkInvestIcon(),
        title: checkInvestSubtitle(),
        desc: `อัตราส่วนการลงทุน = (สินทรัพย์ลงทุน/ความมั่งคั่งสุทธิ) x 100`,
        desc_gray: `${numeral(getInvest).format("0,0.00")} = (${numeral(
          balanceData?.sum_property_invest
        ).format("0,0")} /
        ${numeral(balanceData?.net_wealth).format("0,0")}) * 100 `,
        is_detail: true,
        detail: `คุณมีสินทรัพย์ที่ก่อให้เกิดรายรับน้อยเกินไป ควรจัดสรรการลงทุนเพิ่มพูนมั่งคั่ง`,
      },
    ];
    return newPropertyItems;
  }, []);

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="อัตราส่วนทางการเงิน"
        icon="/images/financial_analysis.svg"
      />
      <PdfCard title={"ประเมินรายรับ - รายจ่าย"}>
        {evulatePropertyItems?.map((propertyItem, index) => {
          return (
            <PdfCardWhite key={index} className={"flex flex-col mt-3"}>
              <div className="flex flex-col mx-2">
                <div className="flex space-x-2 items-center">
                  <div>
                    <img
                      src={`/images/${propertyItem.label_icon}`}
                      className="bg-cover"
                    />
                  </div>
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                    {propertyItem.label}
                  </div>
                  <div
                    className={cn("text-[#7E8393]", STYLE_PDF_TEXT_MEDIUM_11)}
                  >
                    {propertyItem.label_gray}
                  </div>
                </div>

                <div className="flex flex-col items-center mt-1">
                  <div className="flex space-x-2 items-center justify-center">
                    <div>
                      {propertyItem?.icon && (
                        <img
                          src={propertyItem.icon}
                          className="bg-cover w-[24px] h-[24px]"
                        />
                      )}
                    </div>
                    <div className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14)}>
                      {propertyItem.title}
                    </div>
                  </div>
                  <div
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                      "mt-1 text-center "
                    )}
                  >
                    {propertyItem.desc}
                  </div>
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_GRAY_11, "mt-1")}>
                    {propertyItem.desc_gray}
                  </div>
                  {propertyItem.is_detail && (
                    <PdfCardGray className={cn("py-2")}>
                      <div className="flex justify-center items-center px-10">
                        <img src="/images/Lamp.svg" className={cn("")} />
                        <div className={cn("  ml-1", STYLE_PDF_TEXT_NORMAL_11)}>
                          {propertyItem.detail}
                        </div>
                      </div>
                    </PdfCardGray>
                  )}
                </div>
              </div>
            </PdfCardWhite>
          );
        })}
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageFinacialTwo;
